export const logObject = (component: string, page?: string) => ({ component, page, product: 'product' });
